import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { Tipologia } from 'app/models/tipologias.model';
import { ArrowBackComponent } from 'app/modules/GlobalComponents/arrow-back.component';
import { MenuPermisos } from '../models/permisos.model';
import { FormsModule } from '@angular/forms';
import { RolesPermisosService } from '../roles-y-permisos.service';
import { UtilsService } from 'app/modules/utils-service';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable, Subject, takeUntil } from 'rxjs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CONSTANTS } from 'app/core/constants';
import { user } from 'app/mock-api/common/user/data';

@Component({
    selector: 'actualizar-permisos',
    templateUrl: 'actualizar-permisos.component.html',
    imports:[
        CommonModule,
        MatFormFieldModule,
        MatInputModule,
        MatSelectModule,
        MatButtonModule,
        FormsModule,
        MatTooltipModule,

        //components
        ArrowBackComponent,
    ]
})

export class ActualizarPermisosComponent implements OnInit {
    rol1: Tipologia
    rol$: Observable<Tipologia>
    opcionSeleccionada:boolean = true;
    permisos:MenuPermisos[] = []
    rolId:number
    idRolAdministrador: number = CONSTANTS.ID_ROL_ADMINISTRADOR

    private destroy$ = new Subject<void>();

    constructor(
        private _rolesPermisosService: RolesPermisosService,
        private _utilsService: UtilsService,
    ) { 

        this.rol$ = this._rolesPermisosService.rol$

    }

    ngOnInit() { 
        this._rolesPermisosService.rol$
            .pipe(takeUntil(this.destroy$))
            .subscribe((rol: Tipologia) => {
                this.rolId= rol.tipologiaId
                this.cargarPermisos()
        });
    }

    async cargarPermisos() {
        try {
            const permisosBase = await this._rolesPermisosService.getPermisos();
            const permisosRol = await this._rolesPermisosService.getPermisosByRol(this.rolId);

            // habilitado = false
            this.permisos = permisosBase.map(menu => ({
                ...menu,
                options: menu.options.map(opcion => ({
                    ...opcion,
                    habilitado: false
                }))
            }));

            // Si el rol tiene permisos, actualizamos la propiedad habilitado correspondiente
            if (permisosRol && permisosRol.length > 0) {
                this.permisos.forEach(menu => {
                    const menuRol = permisosRol.find(m => m.nombreMenu === menu.nombreMenu);
                    if (menuRol) {
                        menu.options.forEach(opcion => {
                            const opcionRol = menuRol.options.find(o => o.permisoId === opcion.permisoId);
                            if (opcionRol) {
                                opcion.habilitado = opcionRol.habilitado ?? false;
                            }
                        });
                    }
                });
            }

        } catch (err) {
            this._utilsService.showErrorMessage('No se pudieron cargar los permisos. Intenta de nuevo.');
        }
    }

    actualizarPermisos(){
        let body= {
            rolId:this.rolId,
            permisos: this.permisos
        }
        this._rolesPermisosService.postPermisosList(body)
        .then((response:any)=>{
            this._utilsService.openSuccessSnakBar(response.message)
        })
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete()
    }

}